// @ts-check
/** @jsx jsx */
import { gql } from '@apollo/client';
import { graphql } from 'gatsby';
import React from 'react';
import { jsx } from 'theme-ui';
import * as Product from '@bottlebooks/gatsby-plugin-california-pdf/src/templates/VieVinum/helpers/product';

export default function ProductName({
  __typename,
  shortName,
  vintage,
  countryCode,
  classification,
  country,
  countryName,
  denomination,
  region,
  subregion,
  specialClassification,
  vineyard,
}) {
  const product = {
    __typename: __typename?.replace('Bottlebooks_', ''),
    shortName,
    vintage,
    countryCode,
    classification,
    country,
    countryName,
    denomination,
    region,
    subregion,
    specialClassification,
    vineyard,
  };
  if (!shortName) return null;
  //   if (!product.__typename) console.warn('no typename', product);
  return (
    <React.Fragment>
      <span style={{ display: 'block' }}>{Product.originPrefix(product)}</span>
      {Product.nameWithoutOrigin(product)}
      {vintage && (
        <span sx={{ opacity: 0.7, fontWeight: 'normal' }}> {vintage}</span>
      )}
      <span style={{ display: 'block', fontSize: 'smaller' }}>
        {Product.originSuffix(product)}
      </span>
    </React.Fragment>
  );
}

export const fragment = graphql/* GraphQL */ `
  fragment vv_ProductName on Bottlebooks_Product {
    __typename
    shortName
    countryCode: country(format: RAW)
    countryName: country(format: LOCALIZED)
    denomination

    ... on Bottlebooks_Wine {
      classification
      specialClassification
      region
      subregion
      vineyard
      vintage(removeNonVintage: true)
    }
  }
`;

export const ProductNameFragment = gql`
  fragment ProductName on Product {
    __typename
    shortName
    countryCode: country(format: RAW)
    countryName: country(format: LOCALIZED)
    denomination
    ... on Wine {
      classification
      specialClassification
      region
      subregion
      vineyard
      vintage(removeNonVintage: true)
    }
  }
`;
